import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Portfolio from './Portfolio';
import FaStrV2 from './view/FaStrV2';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Portfolio />} />
        <Route path="/projects/fastr-v2" element={<FaStrV2 />} />
      </Routes>
    </Router>
  );
}

export default App;
